import { render, staticRenderFns } from "./ProjectFileAttachListPage.vue?vue&type=template&id=149bcb00&scoped=true&lang=pug&"
import script from "./ProjectFileAttachListPage.vue?vue&type=script&lang=js&"
export * from "./ProjectFileAttachListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149bcb00",
  null
  
)

export default component.exports